import type {
  ReconciliationStatusResponseDTO,
  ReconciliationStatusItemDTO,
} from "../models/reconciliationStatusDto";
import type {
  ReconciliationStatusEntity,
  ReconciliationStatusItemEntity,
} from "../../domain/entities/ReconciliationStatusEntity";

function itemDtoToEntity(
  dto: ReconciliationStatusItemDTO
): ReconciliationStatusItemEntity {
  return {
    accountName: dto.accountName ?? "",
    accountType: dto.accountType === "credit_card" ? "credit_card" : "bank",
    lastReconciledPeriod: dto.lastReconciledPeriod ?? "",
    lastReconciledOn: dto.lastReconciledOn ?? "",
    unmatchedCount: typeof dto.unmatchedCount === "number" ? dto.unmatchedCount : 0,
  };
}

export function reconciliationStatusDtoToEntity(
  dto: ReconciliationStatusResponseDTO
): ReconciliationStatusEntity {
  return {
    items: (dto.items ?? []).map(itemDtoToEntity),
    pagination: {
      total: dto.pagination?.total ?? 0,
      limit: dto.pagination?.limit ?? 5,
      page: dto.pagination?.page ?? 1,
      totalPages: dto.pagination?.total_pages ?? 0,
      hasMore: dto.pagination?.has_more ?? false,
    },
  };
}
